import { Routes, Route } from 'react-router-dom';
import { Landing } from './Landing';
import { Login } from './auth/Login';
import { Register } from './auth/Register';
import { Dashboard } from './app/Dashboard';
import { ForgotPassword } from './auth/ForgotPassword';
import { ResetPassword } from './auth/ResetPassword';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { AdminLogin } from './admin/AdminLogin';
import { AdminDashboard } from './admin/AdminDashboard';
import { EnterpriseManagement } from './admin/EnterpriseManagement';

export function App(){
  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot" element={<ForgotPassword />} />
      <Route path="/reset" element={<ResetPassword />} />

      {/* Admin */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/enterprise" element={<EnterpriseManagement />} />

      {/* Private */}
      <Route element={<ProtectedRoute />}>
        <Route path="/app/*" element={<Dashboard />} />
      </Route>
    </Routes>
  );
}
